import { DqlQuery, Query } from '../field';

export class ContractNumber {

  readonly id: Query.NumberField;
  readonly number: Query.StringField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.NumberField(prefix + 'id');
    this.number = new DqlQuery.StringField(prefix + 'number');
  }

}
